import { createFileRoute } from "@tanstack/react-router";

import UserDetailsFormPage from "~/pages/user/UserDetailsFormPage.tsx";

export const Route = createFileRoute("/_auth/dashboard/user-settings/details")({
    component: UserDetailsFormPage,
});
